const AboutUs = () => {
    return (
        <div className="about-container">
            <h1>
                Curious to Know More?
            </h1>
            <div>
                <h2>
                    We are a fourth-generatioin family-owned farm located just outside of Rich Fountain, Missouri. We specialize in producing premium pasture-raised Black Angus beef, that is grain-finished for a minimum of 180 days prior to processing. This results in a product that we are proud to offer to our customers. Our motivation is not only ensuring the quality of the beef we produce, but also the health of our animals. Thank you for your business!
                </h2>
            </div>
        </div>
    );
};

export default AboutUs;